import Vue from 'vue'
import storageUtils from 'utils/js/storageUtils.js';//本数据工具类
import * as msgUtils from 'utils/js/msgUtils.js';//消息工具类
import * as mixin from 'utils/js/mixin.js';//工具类
import * as httpUrl from "service/api/httpUrl.js";

export default {
    install(Vue, options) {
        /*
         * 封装工具类
         * 在页面中使用'this.$utils.isAllNum()'
         */
        Vue.prototype.$utils = mixin,
        /*
         * 封装消息提示
         * 在页面中使用'this.$msg.success()'
         */
        Vue.prototype.$msg = {
            // success(msg){
            //     msgUtils.messageSuccess(msg);
            // },
            // error(msg){
            //     msgUtils.messageError(msg);
            // },
            // info(msg){
            //     msgUtils.messageInfo(msg);
            // },
            // alert(msg,title='提示',options={}){//提示对话框
            //     return msgUtils.alert(msg,title,options);
            // },
            // alertConfirm(msg,title='提示'){//提示确认框
            //     return msgUtils.alertConfirm(msg,title);
            // },
            // progressLoad(msg,isShow=true){//加载进度框(单例)
            //     return msgUtils.progressLoad(msg,isShow);
            // },
            success(msg,title){
                msgUtils.messageSuccess(msg,title);
            },
            error(msg,title){
                msgUtils.messageError(msg,title);
            },
            info(msg){
                msgUtils.messageInfo(msg);
            },
            fixedError(earr,title='错误提示'){
                msgUtils.fixedError(earr,title);
            },
            // info(msg){
            //     msgUtils.messageInfo(msg);
            // },
            alert(msg,title='提示',options){//提示对话框
                return msgUtils.alert(msg,title,options);
            },
            alertConfirm(msg,title='提示',options){//提示确认框
                return msgUtils.alertConfirm(msg,title,options);
            },
            progressLoad(msg,isShow=true,options){//加载进度框(单例)
                return msgUtils.progressLoad(msg,isShow,options);
            }
        },
        /*
         * 封装本地储存
         * 在页面中使用'this.$storage.getUserInfo()'
         */
        Vue.prototype.$storage = storageUtils,
        /*
         * 常量
         * 在页面中使用'this.$constant.'
         */
        Vue.prototype.$constant = {
            allHttpUrl:httpUrl,
            httpUrl:httpUrl.httpUrl,
            // baseUrl:httpUrl.baseUrl,//ip地址
            fileUploadUrl:httpUrl.fileUploadUrl,//文件上传地址
            clooudFileUploadUrl: httpUrl.clooudFileUploadUrl,
            // downloadUrl:httpUrl.httpUrl.downloadWorks+"?Authorization="+storageUtils.getUserInfo().token+"&",//下载地址
            downloadUrl:httpUrl.httpUrl.downloadWorks+"?Authorization="+storageUtils.getUserInfo().token+"&token="+storageUtils.getUserInfo().token+"&",//下载地址
        }
    }
}
